"use client";

import { cn, editorContentVariants, Field } from "@atlas/core";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { useMemo } from "react";

interface ICatalogDescriptionProps {
  description: string;
}

export function CatalogDescription({ description }: ICatalogDescriptionProps) {
  const raw = description?.trim() ? description : "";
  const safeHtml = useMemo(() => DOMPurify.sanitize(raw), [raw]);

  return (
    <div className="space-y-6">
      <Field orientation="vertical" className="gap-2">
        <div
          className={cn(
            editorContentVariants(),
            "rich-text-editor-content min-h-0 w-full px-0 py-0 leading-relaxed",
          )}>
          {parse(safeHtml)}
        </div>
      </Field>
    </div>
  );
}
